import { createContext } from 'react';

export const OpenPopupContext = createContext({
  positionChannel: null,
});
